import Proptypes from 'prop-types';
import React from 'react';

const DollarSignMonitor = ({ height = '100%', width = '100%' }) => (
  <svg
    height={height}
    version="1.1"
    viewBox="0 0 166 122"
    width={width}
    xmlns="https://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
  >
    <title>Group 19</title>
    <desc>Created with Sketch.</desc>
    <defs />
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth={1}>
      <g
        id="Step-4-/-one-conf-updated-icons-add-bank"
        transform="translate(-217.000000, -520.000000)"
      >
        <g id="Group-17" transform="translate(175.000000, 520.000000)">
          <g id="Group-19" transform="translate(43.000000, 0.000000)">
            <g id="Group-34">
              <g id="Group-35">
                <path
                  className="college-branded-icon-background"
                  d="M83.0165577,0.861146131 C41.3420777,0.861146131 7.55690444,34.8608509 7.55690444,76.7999584 C7.55690444,87.9724562 9.97349983,98.5716159 14.2803595,108.124718 L151.752756,108.124718 C156.059616,98.5716159 158.476211,87.9724562 158.476211,76.7999584 C158.476211,34.8608509 124.691038,0.861146131 83.0165577,0.861146131 Z"
                  fill="#E6F9FB"
                />
                <path
                  d="M8.5001501,108.124718 L155.646474,108.124718"
                  className="college-branded-icon-stroke"
                  stroke="#054C70"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M0.010939109,108.124718 L4.72716744,108.124718"
                  className="college-branded-icon-stroke"
                  stroke="#054C70"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M159.419457,108.124718 L164.135685,108.124718"
                  className="college-branded-icon-stroke"
                  stroke="#054C70"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <path
                d="M82.3738276,122 C66.3610719,122 53.3818858,119.819302 53.3818858,117.128227 C53.3818858,114.437152 66.3610719,112.256454 82.3738276,112.256454 C98.3847425,112.256454 111.365769,114.437152 111.365769,117.128227 C111.365769,119.819302 98.3847425,122 82.3738276,122 Z"
                fill="#E6F9FB"
              />
              <g
                id="Group-13"
                className="college-branded-icon-stroke"
                stroke="#054C70"
                transform="translate(37.081051, 34.280992)"
              >
                <path
                  d="M88.1927711,51.4214876 L88.1927711,62.8484848 C88.1927711,66.0045127 85.645557,68.5619835 82.4999283,68.5619835 L5.68832647,68.5619835 C2.54721408,68.5619835 0,66.0045127 0,62.8484848 L0,51.4214876 L88.1927711,51.4214876 Z"
                  fill="#FFFFFF"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M48.1051479,60.4958678 C48.1051479,62.166706 46.7617353,63.5206612 45.0985761,63.5206612 C43.4378032,63.5206612 42.0920044,62.166706 42.0920044,60.4958678 C42.0920044,58.8274301 43.4378032,57.4710744 45.0985761,57.4710744 C46.7617353,57.4710744 48.1051479,58.8274301 48.1051479,60.4958678 Z"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <polygon
                  fill="#FFFFFF"
                  points="59.1292442 80.661157 30.0657174 80.661157 31.5188938 69.5702479 57.6760679 69.5702479"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22.0481928,80.661157 L68.1489595,80.661157"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M88.1927711,51.4214876 L88.1837393,5.71123136 C88.1837393,2.55747081 85.6367861,0 82.4937375,0 L5.68774394,0 C2.54695322,0 0,2.55747081 0,5.71123136 L0.009031749,51.4214876 L88.1927711,51.4214876 Z"
                  fill="#FFFFFF"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <g id="Group-9" transform="translate(26.056955, 7.057851)">
                  <path d="M36.8943095,18.5653969 C36.8943095,28.8183583 28.6343239,37.1307937 18.4482528,37.1307937 C8.25778937,37.1307937 0,28.8183583 0,18.5653969 C0,8.31243542 8.25778937,0 18.4482528,0 C28.6343239,0 36.8943095,8.31243542 36.8943095,18.5653969 Z" />
                  <g
                    id="Group-11"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    transform="translate(12.355774, 4.737462)"
                  >
                    <path d="M5.58002709,23.9390409 L5.58002709,26.2597155" />
                    <path d="M5.58002709,1.0024724 L5.58002709,3.32314701" />
                    <path
                      d="M0.797146728,18.6156185 C0.797146728,21.1794114 2.86159407,23.2569677 5.40920994,23.2569677 C7.95462959,23.2569677 10.0212731,21.1794114 10.0212731,18.6156185 C10.0212731,16.0518256 7.95462959,13.9742693 5.40920994,13.9742693 C2.86159407,13.9742693 0.797146728,11.8967129 0.797146728,9.33292005 C0.797146728,6.76912715 2.86159407,4.69157083 5.40920994,4.69157083 C7.95462959,4.69157083 10.0212731,6.76912715 10.0212731,9.33292005"
                      strokeWidth={2}
                    />
                  </g>
                </g>
              </g>
            </g>
            <g id="Group-28" transform="translate(103.225630, 84.694215)">
              <path
                d="M29.1123316,14.5310415 C29.1123316,22.5316953 22.6645999,29.0184529 14.7144287,29.0184529 C6.76425746,29.0184529 0.318430012,22.5316953 0.318430012,14.5310415 C0.318430012,6.52847141 6.76425746,0.0417137908 14.7144287,0.0417137908 C22.6645999,0.0417137908 29.1123316,6.52847141 29.1123316,14.5310415"
                fill="#FFFFFF"
              />
              <path
                d="M28.7939016,14.4893277 C28.7939016,22.4899815 22.3461699,28.9767391 14.3959987,28.9767391 C6.44582745,28.9767391 0,22.4899815 0,14.4893277 C0,6.48675762 6.44582745,0 14.3959987,0 C22.3461699,0 28.7939016,6.48675762 28.7939016,14.4893277 Z"
                stroke="#054C70"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <polyline
                id="Stroke-17-Copy"
                points="8.29399101 14.7364822 13.1607537 19.6553073 21.0687622 10.430322"
                stroke="#05C3DE"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

DollarSignMonitor.propTypes = {
  height: Proptypes.string,
  width: Proptypes.string,
};

export default DollarSignMonitor;
